"use client";

import { useQuery } from "@tanstack/react-query";

import { getUserAssociatedLists } from "@/backend/focus";

export const getUserAssociatedListsQueryKey = (
  ownerPublicKey: string,
  userPublicKey: string,
) => ["user-associated-lists", ownerPublicKey, userPublicKey] as const;

export const useUserAssociatedLists = ({
  ownerPublicKey,
  userPublicKey,
  enabled = true,
}: {
  ownerPublicKey: string;
  userPublicKey: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getUserAssociatedListsQueryKey(ownerPublicKey, userPublicKey),
    queryFn: () =>
      getUserAssociatedLists({
        ownerPublicKey,
        userPublicKey,
      }),
    enabled:
      enabled &&
      !!ownerPublicKey &&
      !!userPublicKey &&
      ownerPublicKey !== userPublicKey,
    staleTime: 60_000,
  });
};
